import React, { useEffect, useRef, useState } from "react";

function Map({ address, userLocation, type }) {
  const mapRef = useRef(null);
  const [isGoogleMapsLoaded, setIsGoogleMapsLoaded] = useState(false);

  // Dirección estándar en Bogotá
  const defaultAddress = "Av. Carrera 50 #64-43, Bogotá, Colombia";

  useEffect(() => {
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyAqIUFp7_oiitXFLhKBvms7Mr3W2bRgFxQ`;
    script.async = true;
    script.defer = true;
    script.onload = () => setIsGoogleMapsLoaded(true);
    script.onerror = () => console.error("No se pudo cargar el script de Google Maps.");
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    if (!isGoogleMapsLoaded || !window.google) {
      console.error("Google Maps API no está disponible.");
      return;
    }

    const geocoder = new window.google.maps.Geocoder();
    const map = new window.google.maps.Map(mapRef.current, {
      zoom: 15,
      center: userLocation ? userLocation : { lat: 0, lng: 0 },
    });

    // Utiliza la dirección estándar si no se proporciona ninguna dirección ni ubicación de usuario
    const locationToUse = address || defaultAddress;

    if (locationToUse) {
      geocoder.geocode({ address: locationToUse }, (results, status) => {
        if (status === "OK" && results[0]) {
          map.setCenter(results[0].geometry.location);
          new window.google.maps.Marker({
            map,
            position: results[0].geometry.location,
          });
        } else {
          console.error("No se pudo geocodificar la dirección:", status);
        }
      });
    } else if (userLocation) {
      new window.google.maps.Marker({
        map,
        position: userLocation,
      });
    }
  }, [isGoogleMapsLoaded, address, userLocation]);

  return (
    <div
      ref={mapRef}
      style={{
        height: type === "small" ? "120px" : "400px",
        width: "100%",
      }}
    />
  );
}

export default Map;
